/**
 * 생성기 상태를 분석 이벤트 값으로 옮긴다 — 발화는 하지 않는다(호출하는 곳이 `trackEvent`).
 */
import { type AiGenerateDockRunOutcome } from './aiGenerateDockFeedback';
import { type AiGenerateDockGateKind } from './aiGenerateDockGate';
import {
  type AiGeneratorGate,
  type AiGeneratorRunResult,
} from './events.quiz-ai-generator';

const GATE: Record<AiGenerateDockGateKind, AiGeneratorGate> = {
  open: 'open',
  guest: 'guest',
  chatBusy: 'chat_busy',
  quotaExhausted: 'quota_exhausted',
};

export const toAiGeneratorGate = (kind: AiGenerateDockGateKind) => GATE[kind];

export type AiGeneratorRunEndOutcome = {
  result: AiGeneratorRunResult;
  reason: string;
  created_count: number;
  failed_count: number;
};

/** 거절 사유 — 서버 error code 가 있으면 그것, 없으면 거절 종류. */
const rejectionReason = (
  rejection: Extract<
    AiGenerateDockRunOutcome,
    { kind: 'rejected' }
  >['rejection'],
) => (rejection.kind === 'other' ? rejection.code ?? 'other' : rejection.kind);

export const toAiGeneratorRunEndOutcome = (
  outcome: AiGenerateDockRunOutcome,
): AiGeneratorRunEndOutcome => {
  switch (outcome.kind) {
    case 'success':
      return {
        result: 'success',
        reason: '',
        created_count: outcome.created,
        failed_count: 0,
      };
    case 'partial':
      return {
        result: 'partial',
        reason: '',
        created_count: outcome.created,
        failed_count: outcome.failed,
      };
    case 'rejected':
      return {
        result: 'rejected',
        reason: rejectionReason(outcome.rejection),
        created_count: 0,
        failed_count: 0,
      };
    case 'blocked':
      return {
        result: 'blocked',
        reason: outcome.reason,
        created_count: 0,
        failed_count: 0,
      };
    case 'failed':
    case 'not_generated':
    case 'aborted':
      return {
        result: outcome.kind,
        reason: '',
        created_count: 0,
        failed_count: 0,
      };
  }
};
